import React from "react";

const ShowShimmer = () => {
  return (
    <div className="w-full px-4 md:px-12 py-12 space-y-8 animate-fade-in">
      {[1, 2, 3].map((i) => (
        <div key={i} className="space-y-4">
          <div className="h-8 w-48 animate-shimmer rounded-lg"></div>
          <div className="flex space-x-4 overflow-x-hidden">
            {[1, 2, 3, 4, 5, 6].map((j) => (
              <div
                key={j}
                className="flex-shrink-0 w-32 md:w-44 aspect-[2/3] animate-shimmer rounded-xl"
              ></div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ShowShimmer;
